import React from 'react';
import { BlurFade } from './magicui/blur-fade';

export const PageIntro = ({ eyebrow = 'MAXLIGHT HRVATSKA', title, children, testId, className = '' }) => (
  <header className={`premium-page-intro ${className}`}>
    <BlurFade inView={false}>
      <p className="premium-eyebrow" data-testid={`${testId}-eyebrow`}>{eyebrow}</p>
      <h1 className="premium-title" data-testid={testId}>{title}</h1>
      {children && <div className="premium-intro-copy">{children}</div>}
    </BlurFade>
  </header>
);